import { render, staticRenderFns } from "./CalendarInfo.vue?vue&type=template&id=5cf63572&scoped=true&"
import script from "./CalendarInfo.vue?vue&type=script&lang=js&"
export * from "./CalendarInfo.vue?vue&type=script&lang=js&"
import style0 from "./CalendarInfo.vue?vue&type=style&index=0&id=5cf63572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf63572",
  null
  
)

export default component.exports